<script>
export default {
    mounted: function () {
        this.topbarLight();
    },
    methods: {
        /**
         * Menu clicked show the submenu
         */
        onMenuClick(event) {
            event.preventDefault();
            const nextEl = event.target.nextSibling;
            if (nextEl && !nextEl.classList.contains("show")) {
                const parentEl = event.target.parentNode;
                if (parentEl) {
                    parentEl.classList.remove("show");
                }
                nextEl.classList.add("show");
            } else if (nextEl) {
                nextEl.classList.remove("show");
            }
            return false;
        },
        topbarLight() {
            document.body.setAttribute("data-topbar", "light");
            document.body.removeAttribute("data-layout-size", "boxed");
        },
        boxedWidth() {
            document.body.setAttribute("data-layout-size", "boxed");
            document.body.removeAttribute("data-topbar", "light");
            document.body.setAttribute("data-topbar", "dark");
        },
        coloredHeader() {
            document.body.setAttribute("data-topbar", "colored");
            document.body.removeAttribute("data-layout-size", "boxed");
        }
    }
};
</script>
<template>
    <div class="topnav">
        <div class="container-fluid">
            <div class="offset-1 col-10">
                <nav class="navbar navbar-light navbar-expand-lg topnav-menu ">
                    <div id="topnav-menu-content" class="collapse navbar-collapse text-center">
                        <ul class="navbar-nav">
                            <li class="nav-item">
                                <a class="nav-link font-size-12" href="/filtrar/categoria/1">
                                    Adhesión y Grabado
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link font-size-12" href="/filtrar/categoria/30">
                                    Anestesia
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link font-size-12" href="/filtrar/categoria/2">
                                    Blanqueamiento
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link font-size-12" href="/filtrar/categoria/8">
                                    Endodoncia
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link font-size-12" href="/filtrar/categoria/9">
                                    Equipamiento General
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link font-size-12" href="/filtrar/categoria/13">
                                    Instrumental
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link font-size-12" href="/filtrar/categoria/14">
                                    Operatoria y Estética
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link font-size-12" href="/filtrar/categoria/19">
                                    Manejo de tejidos
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link font-size-12" href="/filtrar/categoria/22">
                                    Terminación y pulido
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link font-size-12 text-primary" href="/listaestudiantes">
                                    Lista de Estudiantes
                                </a>
                            </li>
                            <!--<li class="nav-item dropdown active">
                                <a
                                    class="nav-link dropdown-toggle arrow-none"
                                    href="#"
                                    id="topnav-layout"
                                    role="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    @click="onMenuClick"
                                >
                                    <i class="bx bx-layout mr-2"></i>Layouts
                                    <div class="arrow-down"></div>
                                </a>
                                <div class="dropdown-menu dropdown-menu-right active" aria-labelledby="topnav-layout">
                                    <a class="dropdown-item active" href="javascript:void(0);">Horizontal</a>
                                    <a
                                    class="dropdown-item"
                                    href="javascript:void(0);"
                                    @click="() => $root.changeLayout('vertical')"
                                    >Vertical</a>
                                    <a
                                    @click="topbarLight"
                                    href="javascript: void(0);"
                                    class="dropdown-item"
                                    >Light Topbar</a>
                                    <a @click="boxedWidth" href="javascript: void(0);" class="dropdown-item">Boxed</a>
                                    <a
                                    @click="coloredHeader"
                                    href="javascript: void(0);"
                                    class="dropdown-item"
                                    >Colored Header</a>
                                </div>
                            </li>-->
                        </ul>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</template>
